const SOLAR_GUARDIAN = {
  slug: "solar-guardian",
  name: "Solar Guardian",
  description: "Worn by the champions of light",
  rarity: "epic",
  slot: "armor",
  shopCategory: "metal-armor",
  statChanges: [
    { stat: "armor", value: 30 },
    { stat: "goldColor", value: 25 },
    { stat: "goldRes", value: 12 }
  ],
  sprite: {
    sheet: "wardrobe/metal/metal_yellow",
    frameIndex: 2
  },
  bodySprite: "characters/body/body_gold",
  tags: ["daily-rotation", "metal"]
};
export {
  SOLAR_GUARDIAN
};
//# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsiLi4vLi4vLi4vLi4vLi4vLi4vbGliL2l0ZW1zL2FybW9ycy9tZXRhbC9zb2xhci1ndWFyZGlhbi50cyJdLAogICJzb3VyY2VzQ29udGVudCI6IFsiaW1wb3J0IHsgSXRlbURlZmluaXRpb24gfSBmcm9tICcuLi8uLi90eXBlcyc7XG5cbmV4cG9ydCBjb25zdCBTT0xBUl9HVUFSRElBTjogSXRlbURlZmluaXRpb24gPSB7XG4gIHNsdWc6ICdzb2xhci1ndWFyZGlhbicsXG4gIG5hbWU6ICdTb2xhciBHdWFyZGlhbicsXG4gIGRlc2NyaXB0aW9uOiAnV29ybiBieSB0aGUgY2hhbXBpb25zIG9mIGxpZ2h0JyxcbiAgcmFyaXR5OiAnZXBpYycsXG4gIHNsb3Q6ICdhcm1vcicsXG4gIHNob3BDYXRlZ29yeTogJ21ldGFsLWFybW9yJyxcbiAgc3RhdENoYW5nZXM6IFtcbiAgICB7IHN0YXQ6ICdhcm1vcicsIHZhbHVlOiAzMCB9LFxuICAgIHsgc3RhdDogJ2dvbGRDb2xvcicsIHZhbHVlOiAyNSB9LFxuICAgIHsgc3RhdDogJ2dvbGRSZXMnLCB2YWx1ZTogMTIgfSxcbiAgXSxcbiAgc3ByaXRlOiB7XG4gICAgc2hlZXQ6ICd3YXJkcm9iZS9tZXRhbC9tZXRhbF95ZWxsb3cnLFxuICAgIGZyYW1lSW5kZXg6IDIsXG4gIH0sXG4gIGJvZHlTcHJpdGU6ICdjaGFyYWN0ZXJzL2JvZHkvYm9keV9nb2xkJyxcbiAgdGFnczogWydkYWlseS1yb3RhdGlvbicsICdtZXRhbCddLFxufTtcbiJdLAogICJtYXBwaW5ncyI6ICJBQUVPLE1BQU0saUJBQWlDO0FBQUEsRUFDNUMsTUFBTTtBQUFBLEVBQ04sTUFBTTtBQUFBLEVBQ04sYUFBYTtBQUFBLEVBQ2IsUUFBUTtBQUFBLEVBQ1IsTUFBTTtBQUFBLEVBQ04sY0FBYztBQUFBLEVBQ2QsYUFBYTtBQUFBLElBQ1gsRUFBRSxNQUFNLFNBQVMsT0FBTyxHQUFHO0FBQUEsSUFDM0IsRUFBRSxNQUFNLGFBQWEsT0FBTyxHQUFHO0FBQUEsSUFDL0IsRUFBRSxNQUFNLFdBQVcsT0FBTyxHQUFHO0FBQUEsRUFDL0I7QUFBQSxFQUNBLFFBQVE7QUFBQSxJQUNOLE9BQU87QUFBQSxJQUNQLFlBQVk7QUFBQSxFQUNkO0FBQUEsRUFDQSxZQUFZO0FBQUEsRUFDWixNQUFNLENBQUMsa0JBQWtCLE9BQU87QUFDbEM7IiwKICAibmFtZXMiOiBbXQp9Cg==
